import { PersonDetail } from "./../../../components/Pages/Catalogs/Person/PersonDetail";
import { CreatePersonDto } from "./../../../dtos/catalogs/person/CreatePersonDto";
import { PersonAccountService } from "../../../services/catalogs/PersonAccountService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupPerson } from "../../../components/Shared/NewForms/NFlookupPerson";
import PersonList from "../../../components/Pages/Catalogs/Person/PersonList";

export const Person: IAppEntity = {
  entityType: "catalog",
  title: "Person",
  pluralTitle: "Person Account",
  apiUrl: "Persons",
  apiEnum: ReferenceTypes.CatalogPerson,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(PersonDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(PersonList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupPerson, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new PersonAccountService(this.apiUrl);
  },
  getEmptyModel(): CreatePersonDto {
    return {
      name: "",
      email: "",
      isEmailValidPerson: false,
      phoneNumber: "",
      validToDate: new Date(),
      actualAddress: "",
      issuedDate: new Date(),
      issuedBy: "",
      documentNumber: "",
      documentSeries: "",
      documentType: "",
      citizenship: "",
      addressOfBirth: "",
      dateOfBirth: new Date(),
      tin: "",
      photo: "",
      lastName: "",
      firstName: "",
      // gender:GenderEnum (0 - men, 1 - women);
    };
  },
};
